import React from 'preact/compat';
import Tooltip from '@mui/material/Tooltip';

import colors from '../colors';

const DescriptionTooltip = ({children, description}) => {
    return <Tooltip
        title={description}
        placement="top-start"
        componentsProps={{
            tooltip: {
                sx: {
                    '&.MuiTooltip-tooltip.MuiTooltip-tooltipPlacementTop': {
                        margin: '0 0 5px',
                        padding: '2px 10px 1px',
                        lineHeight: '14px',
                        maxWidth: '160px'
                    },
                    backgroundColor: colors.tooltipBackground,
                    color: colors.tooltipText,
                    border: 'none'
                }
            }
        }}
    >
        {children}
    </Tooltip>
};

export default DescriptionTooltip;
